import assign from 'lodash/assign';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import shuffle from 'lodash/shuffle';
import React from 'react';
import PropTypes from 'prop-types';

import Article from '../components/Article';

import AboutMe from '../../markdown/about-me.md';
import Methodology from '../../markdown/methodology.md';
import Craft from '../../markdown/craft.md';
import Clients from '../../markdown/clients.md';
import Services from '../../markdown/services.md';
import EveryWebsite from '../../markdown/every-website.md';
import Projects from '../../markdown/projects.md';
import Pricing from '../../markdown/pricing.md';
import Colophon from '../../markdown/colophon.md';

const allocate = (sketches, articles) => {
  const totalWordCount = reduce(
    articles,
    (count, article) => count + article.html.length,
    0
  );
  let index = 0;
  const extra = sketches.length - articles.length * 2;
  return map(articles, article => {
    const allocation =
      2 + Math.floor((article.html.length / totalWordCount) * extra);
    const allocated = sketches.slice(index, index + allocation);
    index += allocation;
    return allocated;
  });
};

const renderArticle = (
  article,
  handleNextClick,
  handlePreviousClick,
  location,
  setLeftOffset,
  sketches
) => {
  const { slug } = article;
  const props = assign({}, article, {
    handleNextClick,
    handlePreviousClick,
    key: slug,
    isSelected: location.hash.slice(1) === slug,
    setLeftOffset,
    sketches,
  });
  return <Article {...props} />;
};

class IndexPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sketches: shuffle(props.sketches),
    };
    if (props.articles) {
      props.setChildren(map(props.articles, article => article.slug));
    }
  }

  render() {
    const {
      articles,
      handleNextClick,
      handlePreviousClick,
      location,
      setLeftOffset,
    } = this.props;
    const { sketches } = this.state;
    const allocatedSketches = allocate(sketches, articles);
    return (
      <div className="articles">
        {map(articles, (article, index) =>
          renderArticle(
            article,
            handleNextClick,
            handlePreviousClick,
            location,
            setLeftOffset,
            allocatedSketches[index]
          )
        )}
      </div>
    );
  }
}

IndexPage.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
    })
  ),
  handleNextClick: PropTypes.func.isRequired,
  handlePreviousClick: PropTypes.func.isRequired,
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired,
  }).isRequired,
  setChildren: PropTypes.func.isRequired,
  setLeftOffset: PropTypes.func.isRequired,
  sketches: PropTypes.arrayOf(PropTypes.string),
};

IndexPage.defaultProps = {
  articles: [
    Craft,
    Methodology,
    AboutMe,
    Clients,
    Services,
    EveryWebsite,
    Projects,
    Pricing,
    Colophon,
  ],
  sketches: [
    'accolades-01',
    'bottles-01',
    'layout-01',
    'layout-02',
    'layout-03',
    'layout-04',
    'layout-05',
    'layout-06',
    'layout-07',
    'layout-08',
    'layout-09',
    'layout-10',
    'layout-11',
    'layout-12',
    'layout-13',
    'layout-14',
    'layout-15',
    'layout-16',
    'layout-17',
    'layout-18',
    'layout-19',
    'layout-20',
    'layout-21',
    'layout-22',
    'numbers',
    'pinot-buds-01',
    'pinot-buds-02',
    'ui-icons-01',
    'ui-icons-02',
  ],
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js